// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"8e6166b6bad1350dc7eb","655":"8e1882c694240b101440"}[chunkId] + ".js";
};